import React, { Fragment } from 'react'
import { H4, FormGroup, TextArea } from '@blueprintjs/core'

const SequenceIntro = ({ number, changeContext, context }) => {

    const handleChangeInput = e => {
        changeContext(number, e.target.value)
    }

    return (
        <Fragment>
            <H4 className='text-center margin-bottom-large margin-top-large'>This is your sequence context: it will be seen only on this particular sequence</H4>
            <FormGroup
                className="create-session-label-context context-fill"
            >
                <TextArea
                    style={{ height: "100px" }}
                    fill={true}
                    placeholder='Write context of sequence here ...'
                    onChange={handleChangeInput}
                    name="context"
                    defaultValue={context ? context : ""}
                />
            </FormGroup>

        </Fragment>
    )
}

export default SequenceIntro
